module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEtJREFUeNpidHFxYcAC/jNgB4zoAkwMFIJRA6hgAAuB6PqPK/qwGfAfj0X/cVnCQiCh/CcgDg6D/0gC/3HYio0N1jeaDqhgAECAAQDV/g7q+LulhAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-structure.png
// module id = 2603
// module chunks = 1